export default "__VITE_ASSET__DjLhxdlQ__"